import produce from "immer";
import { IUser } from "../../redux/UserProfileList/userProfile.types";
import { IAuthContextUser } from "./auth.types";
import { IAuthResponse } from "./auth.services";
import { api } from "../../api/api";

export const AUTH_HEADER_KEY = "auth-Token";

export const setSession = (accessToken: string | null) => {
  try {
    if (accessToken) {
      api.defaults.headers.common[AUTH_HEADER_KEY] = `${accessToken}`;
    } else {
      delete api.defaults.headers.common[AUTH_HEADER_KEY];
    }
  } catch (error) {
    console.error("Error during set session:", error);
    throw error;
  }
};

export const mapAuthResponseToUser = (
  data: IAuthResponse,
): IAuthContextUser => {
  return {
    token: data.token,
    isOTPPreview: data.isOTPPreview,
    name: data.user.full_name ?? "",
    security: data.user.module_security ?? [],
    user: {
      full_name: data.user.full_name ?? "",
      email: data.user.email ?? "",
      first_name: data.user.first_name ?? "",
      last_name: data.user.last_name ?? "",
      mobile_no: data.user.mobile ?? "",
      role_id: data.user.role_id ?? -1,
      status: data.user.status,
      user_uuid: data.user.user_uuid ?? "",
      role_name: data.user.role_name ?? "",
      role_value: data.user.role_value ?? "",
      role_group: data.user.role_group ?? "",
      affiliated_billing_company_uuids:
        data.user.affiliated_billing_company_uuids,
    },
  };
};

export const patchAuthUser = (
  existing: IAuthContextUser,
  data: IUser,
): IAuthContextUser => {
  return produce(existing, (draftState) => {
    draftState.security = data.module_security ?? [];
    draftState.user.affiliated_billing_company_uuids =
      data.affiliated_billing_company_uuids;
  });
};
